import { useEffect, useState } from 'react';

function StudentPanel({ user }) {
    const [exams, setExams] = useState([]);
    const [blad, setBlad] = useState('');

    useEffect(() => {
        const fetchExams = async () => {
            try {
                const token = localStorage.getItem('token');
                const res = await fetch('/api/prowadzacy/egzaminy', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                if (!res.ok) throw new Error('Nie udało się pobrać egzaminów');
                const data = await res.json();
                setExams(data);
            } catch (err) {
                setBlad(err.message);
            }
        };

        fetchExams();
    }, []);

    return (
        <div style={{ padding: '0 16px', marginTop:80 }}>
            <h2 >Panel studenta</h2>
            <h3>Moje egzaminy:</h3>
            {blad && <p style={{ color: 'red' }}>{blad}</p>}
            <ul>
                {exams.length === 0 ? (
                    <p>Brak egzaminów.</p>
                ) : (
                    exams.map((exam) => <li key={exam.id}>{exam.title}</li>)
                )}
            </ul>
        </div>
    );
}

export default StudentPanel;